import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { EmbedModeContext } from './embed-mode-with-context';
import { TEmbeddedModeState } from './embed-mode.types';

const MODE_EMBED = 'MODE_EMBED';
const SOURCE = 'SOURCE';

export function useEmbedMode(): {
  isEmbeddedMode: boolean;
  shouldInitializeApplications: boolean;
  embedSource:string | null;
} {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const embeddedModeContext = useContext<TEmbeddedModeState>(EmbedModeContext);

  const isEmbeddedMode =
    window.sessionStorage.getItem(MODE_EMBED) !== null
      ? window.sessionStorage.getItem(MODE_EMBED) === 'true'
      : searchParams.get('mode') === 'embed';
  const shouldInitializeApplications = !isEmbeddedMode
    ? true
    : Boolean(embeddedModeContext.state);

  const embedSource = window.sessionStorage.getItem(SOURCE) !== null
    ? window.sessionStorage.getItem(SOURCE)
    : (searchParams.get('source') ? searchParams.get('source') : 'default');

  useEffect(() => {
    window.sessionStorage.setItem(MODE_EMBED, String(isEmbeddedMode));
    window.sessionStorage.setItem(SOURCE, String(embedSource));
  }, []);

  window.gwh.appGallery.embededmode = isEmbeddedMode;

  return { isEmbeddedMode, shouldInitializeApplications, embedSource };
}
